<template>
  <div
    class="base-switch__container"
  >
    <span
      class="base-switch"
      :class="`base-switch${disabled ? '__disabled' : '__button'}`"
      @click.prevent.stop="onChange"
    >
      <BaseIcon
        :icon="icon"
        class="base-switch__icon"
      />
      <span>
        <slot>{{ label }}</slot>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseSwitch',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return this.value ? 'toggle-on' : 'toggle-off';
    },
  },
  methods: {
    onChange() {
      if (this.disabled) {
        return;
      }
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-switch {
  display: flex;

  &__button {
    cursor: pointer;
  }

  &__container {
    display: flex;
    align-items: center;
  }

  &__disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
